export default "__VITE_ASSET__Lzm6oq3Y__"